var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47581 0 0 4.47581 0 10C0 15.5242 4.47581 20 10 20C15.5242 20 20 15.5242 20 10C20 4.47581 15.5242 0 10 0ZM13.2258 6.77419C13.9395 6.77419 14.5161 7.35081 14.5161 8.06452C14.5161 8.77823 13.9395 9.35484 13.2258 9.35484C12.5121 9.35484 11.9355 8.77823 11.9355 8.06452C11.9355 7.35081 12.5121 6.77419 13.2258 6.77419ZM6.77419 6.77419C7.4879 6.77419 8.06452 7.35081 8.06452 8.06452C8.06452 8.77823 7.4879 9.35484 6.77419 9.35484C6.06048 9.35484 5.48387 8.77823 5.48387 8.06452C5.48387 7.35081 6.06048 6.77419 6.77419 6.77419ZM14.629 13.6371C13.4798 15.0161 11.7944 15.8065 10 15.8065C8.20565 15.8065 6.52016 15.0161 5.37097 13.6371C4.82258 12.9798 5.81452 12.1573 6.3629 12.8105C7.26613 13.8952 8.58871 14.5121 10 14.5121C11.4113 14.5121 12.7339 13.8911 13.6371 12.8105C14.1774 12.1573 15.1734 12.9798 14.629 13.6371Z",
    fill: "#9CA8BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileIcon);
export default __webpack_public_path__ + "static/media/smile-icon.ea176c8b57c0c400fec96d26ed39544b.svg";
export { ForwardRef as ReactComponent };